import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = () => ({
    popoverRoot: css({
        zIndex: 12000 + ` !important`,
    }),
    menuRoot: css({
        overflow: "visible",
        borderRadius: 0,
        boxShadow: "0px 2px 29px 0px rgba(3, 3, 3, 0.15)",
    }),
    menuList: css({
        padding: 0,
    }),
    menuItem: css({
        height: 36,
        fontFamily: "roboto-light",
        fontSize: 12,
        color: Color.neutral[900],
        cursor: "pointer",
        display: "flex",
        overflow: "visible",
        "& a": {
            color: Color.neutral[900],
        },
        "&:hover": {
            backgroundColor: Color.neutral[100],
        },
    }),
    menuItemText: css({
        alignItems: "center",
        display: "flex",
    }),
    menuItemCheckIcon: css({
        minWidth: 0,
        marginTop: 4,
        marginRight: 8,
    }),
});
